'use client'

import React, { useEffect, useState } from 'react'
import { COLLAPSE_ANIMATION_DURATION, COLLAPSE_ANIMATION_EASING_CSS } from '../../../../constants/animationConstants'

interface Props {
    children: React.ReactNode
}

export const CollapsePanelContent = ({ children }: Props): React.ReactElement => {
    const [animateOpen, setAnimateOpen] = useState(false)

    useEffect(() => {
        const frameId = requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                setAnimateOpen(true)
            })
        })
        return () => cancelAnimationFrame(frameId)
    }, [])

    const transitionStyle: React.CSSProperties = {
        display: 'grid',
        gridTemplateRows: animateOpen ? '1fr' : '0fr',
        opacity: animateOpen ? 1 : 0,
        transitionProperty: 'grid-template-rows, opacity',
        transitionDuration: `${COLLAPSE_ANIMATION_DURATION}s`,
        transitionTimingFunction: COLLAPSE_ANIMATION_EASING_CSS,
    }

    return (
        <div className="min-h-0 w-full overflow-hidden" style={transitionStyle}>
            <div className="min-h-0 overflow-hidden">
                <div className="pb-4 w-full">{children}</div>
            </div>
        </div>
    )
}
